import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const s = () => /* @__PURE__ */ o.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ o.jsx(
  "path",
  {
    d: "m22.564 3.48 17.04 29.513a2.96 2.96 0 0 1-2.564 4.44H2.96a2.96 2.96 0 0 1-2.563-4.44L17.437 3.48c1.138-1.973 3.986-1.973 5.127 0M20 6.934 4.67 33.486h30.66zm0 19.937a1.974 1.974 0 1 1 0 3.947 1.974 1.974 0 0 1 0-3.947m0-13.815a1.974 1.974 0 0 1 1.974 1.974v7.894a1.974 1.974 0 0 1-3.948 0V15.03A1.974 1.974 0 0 1 20 13.056",
    fill: "currentColor"
  }
) });
export {
  s as A
};
